import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import { observer } from 'mobx-react';
import { Link } from 'office-ui-fabric-react/lib/components/Link';
import { logUsage } from 'owa-analytics';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyStartSearch } from 'owa-mail-search-actions';
import { searchStore as searchStoreV1, setSearchText as setSearchTextV1, lazySetCurrentSearchSuggestions as lazySetCurrentSearchSuggestionsV1, setGhostText as setGhostTextV1, } from 'owa-mail-search-store';
import { lazyLogEntityClicked } from 'owa-search-service';
import { searchStore as searchStoreV2, lazyOnSearchTextChanged, startSearch } from 'owa-search';
import { formatToArray } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
var classNames = require('classnames/bind');
var styles = require('./SearchSpellCheckerSuggestion.scss');
var SearchSpellCheckerSuggestion = /** @class */ (function (_super) {
    tslib_1.__extends(SearchSpellCheckerSuggestion, _super);
    function SearchSpellCheckerSuggestion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchStore = isMailFeatureEnabled('sea-commonSearchBox')
            ? searchStoreV2
            : searchStoreV1;
        _this.changeSearchTerm = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var onSearchTextChanged;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Log that user clicked on spelling suggestion (for React Mail).
                        logUsage(datapoints.SearchSpellerClicked.datapoint.name);
                        // Log that user clicked on spelling suggestion (for QF).
                        lazyLogEntityClicked.importAndExecute(this.searchStore.latestTraceId, this.searchStore.suggestedSearchTermReferenceId, new Date());
                        if (!isMailFeatureEnabled('sea-commonSearchBox')) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazyOnSearchTextChanged.import()];
                    case 1:
                        onSearchTextChanged = _a.sent();
                        onSearchTextChanged(this.searchStore.alteredQuery);
                        startSearch('SearchSpellCheckerSuggestion');
                        return [3 /*break*/, 3];
                    case 2:
                        // Replace text in search box and kick off search.
                        setSearchTextV1(this.searchStore.alteredQuery);
                        lazyStartSearch('SearchSpellCheckerSuggestion');
                        /**
                         * Remove suggestions in store (since they're no longer relevant
                         * as we changed the search text) and fetch new ghost text.
                         */
                        lazySetCurrentSearchSuggestionsV1.importAndExecute(null, searchStoreV1.displayedQfRequestTime);
                        setGhostTextV1();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Gets altered query string for UI (i.e. bolding corrected words in
         * query string).
         */
        _this.getAlteredQueryString = function () {
            var pieces = [];
            var recourseQuery = _this.searchStore.recourseQuery;
            var flaggedTokens = _this.searchStore.flaggedTokens;
            // Grab first part of string (if it doesn't start with a misspelled word).
            if (flaggedTokens[0].Offset > 0) {
                pieces.push(recourseQuery.substring(0, flaggedTokens[0].Offset));
            }
            // Iterate over flagged tokens returned by the service.
            for (var i = 0; i < flaggedTokens.length; i++) {
                var currentFlaggedToken = flaggedTokens[i];
                var suggestion = currentFlaggedToken.Suggestion, offset = currentFlaggedToken.Offset, length_1 = currentFlaggedToken.Length;
                // Bold the correctly spelled version of the flagged token.
                pieces.push(React.createElement("strong", { key: i }, suggestion));
                // Get the misspelled word from original query so we can remove it.
                var misspelledWord = recourseQuery.substr(offset, length_1);
                // Split the query string so we only replace in the bad part.
                var properlySpelledPart = recourseQuery.substring(0, offset);
                var partWithMisspelledWord = recourseQuery.substring(offset);
                /**
                 * Replace first instance of misspelled word in questionable part of
                 * query with suggestion, and then merge the parts back together.
                 */
                var regExp = new RegExp(misspelledWord);
                recourseQuery =
                    properlySpelledPart + partWithMisspelledWord.replace(regExp, suggestion);
                /**
                 * Check if current flagged token is the last one. If it's not the
                 * last one, add the correctly spelled bit between the 2 flagged
                 * tokens. If it is the last one, just add the rest of the string.
                 */
                var nextIndex = offset + suggestion.length;
                if (i < flaggedTokens.length - 1) {
                    var nextFlaggedToken = flaggedTokens[i + 1];
                    pieces.push(recourseQuery.substring(nextIndex, nextFlaggedToken.Offset));
                }
                else {
                    pieces.push(recourseQuery.substring(nextIndex));
                }
            }
            return pieces;
        };
        return _this;
    }
    SearchSpellCheckerSuggestion.prototype.render = function () {
        if (!this.searchStore.suggestedSearchTerm) {
            return null;
        }
        // Log that spelling suggestion was shown to the user.
        logUsage(datapoints.SearchSpellerRendered.datapoint.name);
        return (React.createElement("div", { style: { display: 'block' }, className: classNames(styles.spellerLabel, this.props.className) }, formatToArray(strings.didYouMeanLabel, React.createElement(Link, { key: "suggestedSearchTerm", onClick: this.changeSearchTerm }, this.getAlteredQueryString()))));
    };
    SearchSpellCheckerSuggestion = tslib_1.__decorate([
        observer
    ], SearchSpellCheckerSuggestion);
    return SearchSpellCheckerSuggestion;
}(React.Component));
export default SearchSpellCheckerSuggestion;
//# sourceMappingURL=SearchSpellCheckerSuggestion.js.map